import { Injectable } from '@angular/core';
import {Subject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ActionEmitterService {

  private static action: Subject<{ name: string, args: any[] }> = new Subject();

  constructor() { }

  static emitActions(action: string) {
    this.action.next(JSON.parse(action));
  }

  get actions$(): Observable<{ name: string, args: any[] }> {
    return ActionEmitterService.action.asObservable();
  }
}
